import { useEffect, useState } from "react";
import { closelightbox } from "../../../util/Functions";
import * as API from "../../../http/api";

import { ModalStyle } from "../../../util/Styles";
import { Search, Delete } from "@mui/icons-material";
import { Button, FlexGrid, Typography } from "@albo-ui/core";
import { MenuItem, TextField, Grid, IconButton, Dialog, DialogActions, DialogContent, DialogTitle, } from "@mui/material";

import moment from 'moment';
import 'moment/locale/es';

const ContraCargoSpei = (props) => {
    const [form, setForm] = useState("");
    const [disabled, setDisabled] = useState(true);
    const [zPos, setZPos] = useState(45);
    const [search, setSearch] = useState("");
    
    useEffect(() => {
        var data = {
            info: {
                accountNumber: props.spacesList[0]["accountNumber"],
                description: "I. Se valida que la operación fue realizada accionando los siguientes factores de seguridad: Face ID, huella dactilar o contraseña de móvil asociado a tu cuenta albo. Información a la cual solamente el propietario de la cuenta de fondos de pago electrónico tiene acceso por medio de la aplicación, por lo cual la aclaración ha resultado en contra.",
                event_id: "",
                event_date: new Date(),
                resolution: "not_applicable",
                resolution_date: new Date(),
            },
            transaction: [
                { amountFormated: props.data.amountFormated, amount: props.data.amount, cdate: props.data.cdate, tracking_key: props.data.tracking_key }
            ],
            customer: props.customer,
            title: "Dictamen de Reclamación"
        };
        setForm(JSON.parse(JSON.stringify(data)));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const onHandleSearchTx = async () => {
        if (search && onValidateClave(search)) {
            setZPos(-1);
            props.changeLoader(true);

            let f = form;
            let data = {
                space: { uuid: props.spaceUuid },
                filter: {
                    genericFilters: [{ tracking_key: search }],
                    results_per_page: 10,
                    page_number: 1,
                },
            };

            let request = await API.service("spaceListTxAdv", data, props.pos, props.changeAlert, props.changeLoader, props.history);

            if (request.status === 200 && request.data.data.response === "OK") {
                for (let i = 0; i < request.data.data.widget.length; i++) {
                    let widget = request.data.data.widget[i];
                    if (widget.type === "spaceListTxAdv" && widget.data.content.length > 0) {
                        f["transaction"].push({
                            amountFormated: widget.data.content[0].amountFormated,
                            amount: widget.data.content[0].amount,
                            cdate: widget.data.content[0].cdate,
                            tracking_key: widget.data.content[0].tracking_key,
                        });
                        setForm(JSON.parse(JSON.stringify(f)));
                        onValidateForm(f);
                    } else {
                        props.changeAlert(true, "error", "No se encontraron resultados.");
                    }
                }
            }

            setZPos(45);
            props.changeLoader(false);
        } else {
            props.changeAlert(true, "error", "La clave de rastreo ingresada, ya se encuentra en el listado.");
        }
    };
    const onValidateClave = (key) => {
        const check = form["transaction"]?.some(item => item.tracking_key === key);
        return !check;
    };
    const onHandleDelete = (key) => {
        let f = form;
        let filterList = f["transaction"].filter((i) => i.tracking_key !== key)
        f["transaction"] = filterList;
        setForm(JSON.parse(JSON.stringify(f)));
        onValidateForm(f);
    };
    const onHandleChange = (nodo, key, e) => {
        let f = form;
        let value = e.target.value

        if (nodo) {
            if (key.includes("date")) {
                f[String(nodo)][key] = new Date(value).toISOString();
            } else {
                f[String(nodo)][key] = key === "event_id" ? value.toUpperCase() : value;
            }
        } else {
            f[String(key)] = value;
        }

        setForm(JSON.parse(JSON.stringify(f)));
        onValidateForm(f);
    };
    const onValidateForm = (f) => {
        const allFieldsFilled = 
        Object.values(f.info).every((field) => {
            if (typeof field === 'object') {
                return Object.values(field).every((value) => String(value).trim() !== '');
            }
            return String(field).trim() !== '';
        }) && 
        f.transaction.length > 0 && 
        Object.values(f).filter(value => typeof value === 'string').every(value => String(value).trim() !== '');
        setDisabled(!allFieldsFilled);
    };

    const onHandleDownload = async () => {
        props.changeLoader(true);
        setZPos(-1);

        var data = {
            type: "spei",
            content: form,
            url: "signed",
            agent_uuid: JSON.parse(localStorage.session).uuid
        };

        let request = await API.service("cartasDocs", data, props.pos, props.changeAlert, props.changeLoader, props.history);
        if (request.status === 200) {
            if (request.data.data.response === "OK") {
                var dataResult = request.data.data.widget[0].content.url;
                props.changeAlert(true, "success", "Carta contra cargos creada con éxito");
                window.open(dataResult, "_blank");
            } else {
                props.changeAlert(true, "error", "Error al crear carta de contra cargos.");
            }
        }
        setZPos(45);
        closelightbox();
        props.changeLoader(false);
    };

    return (
        <Dialog open={true} sx={{zIndex: zPos}} maxWidth={"md"} fullWidth>
            <ModalStyle property={String(false)}>
                 {props.data && form && <DialogTitle>
                    <Grid container>
                    <Grid item xs={12}>
                        <Typography variant="h2">CARTA SPEI</Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <Typography variant="smallTitle" style={{ paddingTop: -15 }}>
                            {form["title"]}
                        </Typography>
                    </Grid>
                    </Grid>
                </DialogTitle>}

                {props.data && form && (
                    <DialogContent>
                    <Grid container>
                        <Grid container spacing={2}>
                            <Grid item xs={6}>
                                Nombre del cliente: <b>{form["customer"]["name"]}</b>
                            </Grid>
                            <Grid item xs={6}>
                                Identificador de la Cuenta: <b>{form["info"]["accountNumber"]}</b>
                            </Grid>
                        </Grid>
                        <Grid item xs={12} mb={2}><hr/></Grid>

                        <Grid container spacing={2}>
                            <Grid item xs={6}>
                                <TextField label="Ticket de Reclamación" value={form["info"]["event_id"]} onChange={onHandleChange.bind(this, "info", "event_id")} inputProps={{ minLength: 8, maxLength: 22, style: { textTransform: "uppercase" }}} size="small" fullWidth/>
                            </Grid>
                            <Grid item xs={6}>
                                <TextField type={"date"} label={"Fecha de reclamación"} InputLabelProps={{ shrink: true }} sx={{cursor: 'pointer'}}
                                    value={ form["info"]["event_date"] ? new Date(form["info"]["event_date"]).toJSON().substring(0, 10) : form["info"]["event_date"]} 
                                    size="small" fullWidth 
                                    onChange={onHandleChange.bind(this, "info", "event_date")}                 
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <TextField label="Resultado del análisis" select value={form["info"]["resolution"] || 0} disabled onChange={onHandleChange.bind(this, "info", "resolution")} size="small" fullWidth >
                                    <MenuItem value={0} disabled>Seleccione</MenuItem>
                                    <MenuItem value={"applicable"}>PROCEDE</MenuItem>
                                    <MenuItem value={"not_applicable"}>NO PROCEDE</MenuItem>
                                </TextField>
                            </Grid>
                            <Grid item xs={6}>
                                <TextField type={"date"} label={"Fecha de resolución"} InputLabelProps={{ shrink: true }} sx={{cursor: 'pointer'}}
                                    value={ form["info"]["resolution_date"] ? new Date(form["info"]["resolution_date"]).toJSON().substring(0, 10) : form["info"]["resolution_date"]} 
                                    size="small" fullWidth 
                                    onChange={onHandleChange.bind(this, "info", "resolution_date")}                 
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    multiline minRows={2} disabled value={form["info"]["description"]} onChange={onHandleChange.bind(this, "info", "description")} label="Descripción del análisis" size="small" fullWidth />
                            </Grid> 
                        </Grid>

                        <Grid item xs={12} mb={2}><hr/></Grid>

                        <Grid container spacing={2}>
                            <Grid item xs={5} style={{fontWeight: "bolder"}} mb={2}>
                                Seleccionar Tx´s adicionales
                            </Grid>
                            <Grid item xs={7} display={"flex"} alignItems={"center"} justifyContent={"space-between"}>
                                <TextField
                                    label={"Buscar por clave de rastreo..."} value={search} color="secondary" size="small" sx={{mb: 4}} fullWidth
                                    onChange={(e) => setSearch(e.target.value)}
                                    InputProps={{
                                        endAdornment: (
                                            <IconButton onClick={onHandleSearchTx.bind(this)}>
                                                <Search />
                                            </IconButton>
                                        ),
                                    }}
                                />
                            </Grid>
                        </Grid>

                        { form["transaction"].map((item, i) => 
                            <Grid key={`txs-${i}`} mb={2} container spacing={1}>
                                <Grid item xs={11}>
                                    <Grid item>Monto de la operación: <b>${item["amount"]}</b></Grid>
                                    <Grid item>Fecha y hora de la operación: <b>{moment(item["cdate"]).format("LL, H:mm:ss")}</b></Grid>
                                    <Grid item>Clave de Rastreo: <b>{item["tracking_key"]}</b></Grid>
                                </Grid>
                                <Grid item xs={1}>
                                    <IconButton onClick={onHandleDelete.bind(this, item["tracking_key"])}>
                                        <Delete/>
                                    </IconButton>
                                </Grid>
                            </Grid>
                        )}
                    </Grid>
                    </DialogContent>
                )}

                <DialogActions>
                    <FlexGrid fullWidth fullHeight justify="space-between" alignItems="space-between" style={{ marginTop: "20px", display: "flex" }}>
                        <FlexGrid item>
                            <Button onClick={closelightbox} buttonType="secondary" size="normal">
                                Cancelar
                            </Button>
                        </FlexGrid>
                        <FlexGrid item style={{ textAlign: "end" }}>
                            <Button onClick={onHandleDownload} disabled={disabled} size="normal">
                                Descargar
                            </Button>
                        </FlexGrid>
                    </FlexGrid>
                </DialogActions>
            </ModalStyle>
        </Dialog>
    );
};

export default ContraCargoSpei;
